import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMExperienceImpressionReturnType extends GTMEventReturnType {
    exp_experiment_string: string;
    exp_variant_string: string;
}

interface GTMExperienceImpressionModelData {
    experiment: string;
    variant: string;
}

export default class GTMExperienceImpressionModel extends GTMBaseModel {
    public static parseToGTMData({
        experiment,
        variant
    }: GTMExperienceImpressionModelData): GTMExperienceImpressionReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'experience_impression',
            exp_experiment_string: experiment,
            exp_variant_string: variant
        };
    }
}
